module.exports = __webpack_public_path__ + "img/ZWF_Jan_Gorczak.94dbc8f4.jpg";